<template>
  <div id="contenedor-subtiposobras-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoSubTipoObra="registrarNuevoSubTipoObra"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoSubTiposObras="getSubTiposObras"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoSubTipoObra"
      :width="!$vuetify.breakpoint.xs ? '500' : '90%'">
      <registrar-nuevo-sub-tipo-obra
        v-if="mostrarVentanaRegistrarNuevoSubTipoObra"
        v-on:cerrar="cerrarRegistrarNuevoSubTipoObra">
      </registrar-nuevo-sub-tipo-obra>
    </v-dialog>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
    v-if="esteSubTipoObra"
      v-model="mostrarVentanaEditarSubTipoObra"
      :width="!$vuetify.breakpoint.xs ? '500' : '90%'">
      <editar-sub-tipo-obra
      :subTipoObraEditar="esteSubTipoObra"
        v-on:cerrar="cerrarEditarSubTipoObra">
      </editar-sub-tipo-obra>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog
      v-if="esteSubTipoObra"
      v-model="mostrarVentanaEliminarSubTipoObra"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-sub-tipo-obra
      :subTipoObraEliminar="esteSubTipoObra"
        v-on:cerrar="cerrarEliminarSubTipoObra">
      </eliminar-sub-tipo-obra>
    </v-dialog>
  </div>
</template>

<script>
import SUB_TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/subtiposobras/subTiposObras.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoSubTipoObra from '@/components/administracion/configuracion/catalogos/subtiposobra/Nuevo.vue';
import EditarSubTipoObra from '@/components/administracion/configuracion/catalogos/subtiposobra/Editar.vue';
import EliminarSubTipoObra from '@/components/administracion/configuracion/catalogos/subtiposobra/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'TiposObrasDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoSubTipoObra,
    EditarSubTipoObra,
    EliminarSubTipoObra,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoSubTipoObra: false,
      mostrarVentanaEditarSubTipoObra: false,
      mostrarVentanaEliminarSubTipoObra: false,
      esteSubTipoObra: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    subTiposObras: {
      query: SUB_TIPOS_OBRAS,
    },
  },
  mounted() {
    eventBus.$on('editar-sub-tipo-obra', (subTipoObra) => {
      this.esteSubTipoObra = subTipoObra;
      this.mostrarVentanaEditarSubTipoObra = true;
    });
    eventBus.$on('eliminar-sub-tipo-obra', (subTipoObra) => {
      this.esteSubTipoObra = subTipoObra;
      this.mostrarVentanaEliminarSubTipoObra = true;
    });
  },
  methods: {
    registrarNuevoSubTipoObra() {
      this.mostrarVentanaRegistrarNuevoSubTipoObra = true;
    },
    cerrarRegistrarNuevoSubTipoObra() {
      this.mostrarVentanaRegistrarNuevoSubTipoObra = false;
    },
    cerrarEditarSubTipoObra() {
      this.mostrarVentanaEditarSubTipoObra = false;
      this.esteSubTipoObra = null;
    },
    cerrarEliminarSubTipoObra() {
      this.mostrarVentanaEliminarSubTipoObra = false;
      this.esteSubTipoObra = null;
    },
  },
  computed: {
    getSubTiposObras() {
      if (!this.subTiposObras) return [];
      return this.subTiposObras
      // Filtrar por Texto de Busqueda
        .filter((subTipoObra) => {
          if (!this.filtros.buscarTexto) return subTipoObra;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(subTipoObra.descripcion);
          return (
            expt.test(descripcion)
            || expt.test(subTipoObra.descripcion)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
